import { render, staticRenderFns } from "./EffectTable.vue?vue&type=template&id=9a66fc84&scoped=true&"
import script from "./EffectTable.vue?vue&type=script&lang=js&"
export * from "./EffectTable.vue?vue&type=script&lang=js&"
import style0 from "./EffectTable.vue?vue&type=style&index=0&id=9a66fc84&scoped=true&lang=scss&"
import style1 from "./EffectTable.vue?vue&type=style&index=1&id=9a66fc84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a66fc84",
  null
  
)

export default component.exports